import React, { useEffect, useState } from "react";
import TextEditor from "./Editornew";

import {getMedicationById,getAllergyById,getImmuzationsById,getObservationById} from "../../api/list"

const EditorContainer: React.FC = () => {
    const [, setEditorData] = useState(" ");
// **************************** Hooks Imports ****************************
//   const { id }: any = useParams();
  const [allergy, setAllergy] = useState<any>(' ');
  const [medications, setMedications] = useState<any>(' ');
  const [immuzations, setImmuzations] = useState<any>(' ');
  const [observation, setObservation] = useState<any>(' ');
  const [, setLoader] = useState<Boolean>(false);
  const [limit, ] = useState(5);



const generateHTMLTable = (data: any[]) => {
    if (data.length === 0) return "<p>No data available</p>"; // Handle empty data case
    // Extract headers dynamically from object keys
    const headers = Array.from(new Set(data.flatMap(Object.keys)));
  
    // Create the table header
    let table = `<table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse;">`;
    table += "<thead><tr>";
    headers.forEach(header => {
      table += `<th>${header}</th>`;
    });
    table += "</tr></thead>";
  
    // Create the table body with rows of data
    table += "<tbody>";
    data.forEach((row) => {
      table += "<tr>";
      headers.forEach((key) => {
        let value = row[key];
  
        // Handle arrays by joining them
        if (Array.isArray(value)) {
          value = value.length ? value.join(", ") : "NA";
        }
  
        // Replace null, undefined, or empty strings with "NA"
        value = value ?? "NA";
  
        table += `<td>${value}</td>`;
      });
      table += "</tr>";
    });
    table += "</tbody>";
  
    // Close the table tag
    table += "</table>";
  
    return table;
  };


  

  interface DataItem {
    type: string;
    deviceName: string | null;
    recordedDate: string;
    value: string | null;
    unit: string | null;
    // Add other properties if needed
  }
  
  function generateDataHtml(data: DataItem[]): string {
    const formatData = (data: any) => {
      if (data?.type === "bloodPressure") {
        if (
          data?.systolicValue &&
          data?.diastolicValue !== "0" &&
          data?.diastolicValue &&
          data?.systolicValue !== "0"
        )
          return `${
            data?.systolicValue && data?.diastolicValue !== "0"
              ? data?.systolicValue
              : ""
          }/${
            data?.diastolicValue && data?.systolicValue !== "0"
              ? data?.diastolicValue
              : ""
          } ${data?.unit ?? ""}`;
        else return "-";
      } else if (data?.value && data?.unit) {
        return `${data?.value} ${data?.unit}`;
      } else {
        return "-";
      }
    };
  
    const htmlString = data
      .map(
        (item) =>
          `<p><b> ${item.type} </b> : ${formatData(item)} (${item.recordedDate})</p>`
      )
      .join('');
  
    return htmlString;
  }

  const getMedications = (
    id: string | number,
    status?: string
  ) => {
    let waitForLoadingCount = 0;

    const fetchMedication = () => {
      getMedicationById(id, {
        page: 1,
        limit,
        status,
        sort_by: 'created_at',
        sort_dir: 'asc',
      }).then((res) => {
        if (!res?.success && res?.result?.loading && waitForLoadingCount === 0) {
          waitForLoadingCount += 1;
          setTimeout(fetchMedication, 5000);
        } else if (res?.result?.data) {
          const formattedMedications = generateHTMLTable(res.result.data);
            setMedications(formattedMedications);
        }
        setLoader(false);
      });
    };
  
    fetchMedication();
  };
  

  const getAllergy = (
    id: string | number,
    status?: string
  ) => {
    let waitForLoadingCount = 0;

    const fetchAllergy= () => {
        getAllergyById(id, {
        page: 1,
        limit,
        status,
        sort_by: 'created_at',
        sort_dir: 'asc',
      }).then((res) => {
        if (!res?.success && res?.result?.loading && waitForLoadingCount === 0) {
          waitForLoadingCount += 1;
          setTimeout(fetchAllergy, 5000);
        } else if (res?.result?.data) {
          const formattedAllergy = generateHTMLTable(res.result.data);
          setAllergy(formattedAllergy);
        }
        setLoader(false);
      });
    };
    fetchAllergy();
  };
  


  const getImmuzations= (
    id: string | number,
    status?: string
  ) => {
    let waitForLoadingCount = 0;

    const fetchImmuzations = () => {
      getImmuzationsById(id, {
        page: 1,
        limit,
        status,
        sort_by: 'created_at',
        sort_dir: 'asc',
      }).then((res) => {
        if (!res?.success && res?.result?.loading && waitForLoadingCount === 0) {
          waitForLoadingCount += 1;
          setTimeout(fetchImmuzations, 5000);
        } else if (res?.result?.data) {
          const formattedImmuzations = generateHTMLTable(res.result.data);
          setImmuzations(formattedImmuzations);
        }
        setLoader(false);
      });
    };
  
    fetchImmuzations();
  };
  

  const typeOrder: any = {
    BP: "bloodPressure",
    Temp: "temperature",
    Pulse: "heartrate",
    Weight: "weight",
    Resp: "respirations",
    BS: "bloodSugar",
    O2: "oxygenSaturation",
    Pain: "painLevel",
    Height: "height",
  };

  const getObservation= (
    id: string | number,
    status?: string
  ) => {
    let waitForLoadingCount = 0;

    const fetchObservation = () => {
      getObservationById(id).then((res) => {

        if (!res?.success && res?.result?.loading && waitForLoadingCount === 0) {
          waitForLoadingCount += 1;
          setTimeout(fetchObservation, 5000);
        } 
          else if (res?.result?.data ){
            
            const filteredOrderedData = res?.result?.data
              .map((item: any) => {
                const match = Object.entries(typeOrder).find(
                  ([key, value]) => value === item.type
                );
                return match ? { ...item, observationType: match[0] } : null;
              })
              .filter(Boolean);

            const htmlData=generateDataHtml(filteredOrderedData)
            setObservation(htmlData);

          // const formattedImmuzations = generateHTMLTable(res.result.data);
          // setObservation(formattedImmuzations);
        }
        setLoader(false);
      });
    };
  
    fetchObservation();
  };
  


  useEffect(() => {
    getMedications('217');
    getAllergy('217')
    getImmuzations('217')
    getObservation('217')
  }, []);



    const handleEditorChange = (event: React.FormEvent, data: string) => {

        setEditorData(data);
    };




    return (
        <div className="w-[100%] p-5 bg-white border border-gray-300 shadow-md  flex flex-col h-[80vh] scrollbar-hidden">
        {/* <h2 className="text-xl font-semibold mb-4">Notes Editor</h2> */}

        
        
        {/* Editor Scrollable Area */}
        <div className="flex-grow overflow-y-auto ">
            
            <TextEditor 
           
            value={`
              <div>
                <span style="font-size: 18px ;background-color:hsl(60, 75%, 60%); padding: 2px 4px; border-radius: 4px;">
                <strong>Medication</strong></span> ${medications}
                <br><span style="font-size: 18px; background-color:hsl(60, 75%, 60%); padding: 2px 4px; border-radius: 4px;">
                <strong>Allergy</strong></span> ${allergy}
                <br><span style="font-size: 18px ; background-color:hsl(60, 75%, 60%); padding: 2px 4px; border-radius: 4px;">
                <strong>Immunizations</strong></span> ${immuzations}
                <br><span style="font-size: 18px ;background-color:hsl(60, 75%, 60%); padding: 2px 4px; border-radius: 4px;">
                <strong>Observation</strong></span>${observation}
              </div>
            `}
            handleChange={handleEditorChange} 
          />
        </div>
        
        {/* Toolbar */}
        <div className="mt-4">
            {/* Add your toolbar here */}
            <button className="bg-[#3b98b3] hover:bg-[#215564] text-white px-4 py-2 rounded-md">Save</button>
        </div>
    </div>
    );
};

export default EditorContainer;
